import { render, staticRenderFns } from "./UserLatests.vue?vue&type=template&id=615c50dc&"
import script from "./UserLatests.vue?vue&type=script&lang=js&"
export * from "./UserLatests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports